import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectSelectedFilters,
  selectExistParams,
} from '../../store/entities/selectors';
import { getAudioList } from '../../store/system/actions';
import { makeStyles } from '@material-ui/core/styles';
import { paramsToDeleteHelper } from '../../utils/helpers';
import MiniFilterItem from '../MiniFilterItem';

export interface IOptionsItem {
  value: string;
  text: string;
  selected: boolean;
}

export interface IFilter {
  name: string;
  parent: string | null;
  title: string;
  options: IOptionsItem[];
}

export interface ISelectedFilterItem {
  name: string;
  title: string;
  value: string;
  text: string;
}

export interface onClickHandler {
  onClickFilter?: (data: { [name: string]: string }) => void;
}

export default function MiniFilterList() {
  const styles = useStyles();
  const dispatch = useDispatch();
  const existParams = useSelector(selectExistParams);
  const selectedFilters = useSelector(selectSelectedFilters);
  const isFilter = selectedFilters?.length > 0

  if (!isFilter) {
    return null;
  }

  const onClickFilter = (params: { [name: string]: string }) => {
    paramsToDeleteHelper(params, existParams);
    const data = {
      ...existParams,
      ...params,
    };
    dispatch(getAudioList(data));
  };

  return (
    <div className={styles.miniFilterListContainer}>
      {selectedFilters?.map((f: ISelectedFilterItem) => (
        <MiniFilterItem key={f.name} {...f} onClickFilter={onClickFilter} />
      ))}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  miniFilterListContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 20,
  },
}));
